import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Input, Tooltip, Form, Modal, Space, Tag } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
const { Text } = Typography;

export const SatisfacaoCadCores = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);

  useEffect(() => {
    listar();
  }, []);

  // LISTAR
  const listar = async () => {
    setLoading(true);
    const api = await http("get", `v1/satisfacao_opcoes_cores/listar`, []);
    if (api.statusCode === 200) {
      dispatch({ type: "LOAD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const criar = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/satisfacao_opcoes_cores/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "ADD", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterar = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/satisfacao_opcoes_cores/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      if (api?.response?.data) dispatch({ type: "UPDATE", payload: api?.response?.data });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarLocalidade = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/satisfacao_opcoes_cores/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao_key: api.response.data.descricao_key,
        cor: api.response.data.cor,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarLocalidade = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/satisfacao_opcoes_cores/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      dispatch({ type: "DELETE", payload: { id: id } });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Key",
      dataIndex: "descricao_key",
    },
    {
      title: "Cores",
      dataIndex: "cor",
      render: (_, item) => <Tag color={item.cor}>{item.cor}</Tag>,
      sorter: false,
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 50,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Button loading={loading} onClick={() => carregarLocalidade(e.id)} icon={<EditOutlined />} />
          <Button
            loading={loading}
            danger
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deletarLocalidade(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterar(formulario);
    } else {
      criar(formulario);
    }
  };

  // FORMULÁRIO
  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Cor
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={600}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" span={24}>
            <Form.Item
              name="descricao_key"
              label="Descrição Chave"
              rules={[{ required: true, message: "Digite a chave!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Form.Item name="cor" label="Cor" rules={[{ required: true, message: "Digite a cor em hexadecimal!" }]}>
              <Input size="large" disabled={loading} placeholder="Informe a cor em hexadecimal" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Pesquisa Satisfação" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title={["Pesquisa Satisfação", "Cores"]}
              subtitle="Cadastro de Cores"
              icon={<PlusOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
